import reducer from './reducers';
import * as appointmentAnalysesActions from './actions';
import * as appointmentAnalysesSelectors from './selectors';

export { appointmentAnalysesActions, appointmentAnalysesSelectors };
export default reducer;